import { ButtonSection } from "./ButtonSection";
import { LinkSection } from "./LinkSection";
import type { ResourceSection as ResourceSectionType } from "./types";

interface ResourceSectionProps {
  section: ResourceSectionType;
}

export const ResourceSection = ({ section }: ResourceSectionProps) => {
  if (section.link) {
    return <LinkSection section={section} onClick={section.onClick} />;
  }

  return <ButtonSection section={section} />;
};
